import { ReactComponent } from 'assets/social/medium.svg';
import styled from 'styled-components';

export default styled(ReactComponent)`
  ${props => props}
  color: ${props => props.theme.old.colors[props.color]};
  stroke: ${props => props.theme.old.colors[props.stroke]};
  fill: ${props => props.theme.old.colors[props.fill]};
  transition: ${props => props.theme.old.transition.default};
  width: ${props => props.size || '24px'};
  height: ${props => props.size || '24px'};
`;